<template>
    <Shell :transition="transition">
        <template #header>
            <div class="flex items-center">
                <button class="p-2 rounded-lg hover:bg-black-20%" :title="__('Voltar')" @click="voltar()">
                    <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                    </svg>
                </button>

                <div class="ml-2">
                    <div class="font-bold text-lg">{{ __('Iniciar novo atendimento') }}</div>
                </div>
            </div>
        </template>

        <div class="p-4">
            <div class="bg-white p-4 rounded shadow">
                <div v-if="validationError" class="bg-red-100 text-red-900 text-sm p-2 rounded">
                    {{ validationError }}
                </div>

                <div v-if="alreadyHasContact">
                    <div class="bg-gray-100 rounded p-2 text-sm">
                        <div class="font-bold">{{ contact.atributos_extras.name }}</div>
                        {{ contact.atributos_extras.email }}
                    </div>
                </div>

                <div v-else>
                    <label class="block" v-if="showName">
                        <input type="text" v-model="name" :placeholder="__('Nome')" class="input" />
                    </label>

                    <label class="mt-4 block" v-if="showEmail">
                        <input type="email" v-model="email" :placeholder="__('Digite seu e-email')" class="input" />
                    </label>
                </div>

                <div v-show="guanabara && showFilialGuanabara" class="mt-half-unit">
                    <div class="text-gray-700">{{ __('Informe sua filial') }}</div>
                    <div class="relative">
                        <select class="input" v-model="filialGuanabara">
                            <option value="">Selecione...</option>
                            <option value="001">Filial 01</option>
                            <option value="002">Filial 02</option>
                            <option value="003">Filial 03</option>
                            <option value="004">Filial 04</option>
                            <option value="005">Filial 05</option>
                            <option value="006">Filial 06</option>
                            <option value="007">Filial 07</option>
                            <option value="008">Filial 08</option>
                            <option value="009">Filial 09</option>
                            <option value="010">Filial 10</option>
                            <option value="011">Filial 11</option>
                            <option value="012">Filial 12</option>
                            <option value="013">Filial 13</option>
                            <option value="014">Filial 14</option>
                            <option value="015">Filial 15</option>
                            <option value="016">Filial 16</option>
                            <option value="017">Filial 17</option>
                            <option value="018">Filial 18</option>
                            <option value="020">Filial 20</option>
                            <option value="023">Filial 23</option>
                            <option value="025">Filial 25</option>
                            <option value="026">Filial 26</option>
                            <option value="028">Filial 28</option>
                            <option value="029">Filial 29</option>
                            <option value="030">Filial 30</option>
                            <option value="031">Filial 31</option>
                            <option value="999">Galpão Belem</option>
                        </select>

                        <div class="absolute top-0 right-0 h-full mr-2 flex items-center justify-center">
                            <alo-icon icon="outline-chevron-down" class="w-5 h-5 text-gray-500" />
                        </div>
                    </div>
                </div>

                <label class="mt-4 block" v-if="showDepartment">
                    <div class="label">{{ __('Departamento') }}</div>
                    <div class="relative">
                        <select class="input" v-model="departamentoToken">
                            <option value="">{{ __('Selecione...') }}</option>

                            <option
                                v-for="departamento in availableDepartments"
                                :key="departamento.token"
                                :value="departamento.token"
                                :selected="departamentoToken == departamento.token"
                            >
                                {{ departamento.nome }}
                            </option>
                        </select>

                        <div class="absolute top-0 right-0 h-full mr-2 flex items-center justify-center">
                            <alo-icon icon="outline-chevron-down" class="w-5 h-5 text-gray-500" />
                        </div>
                    </div>
                </label>

                <div v-if="selectedDepartment && selectedDepartment.custom_fields" class="mt-4">
                    <FormClient
                        ref="formClient"
                        :fields="selectedDepartment.custom_fields"
                        :value="$store.state.perfil"
                    />
                </div>

                <div v-if="invalidDepartmentCode" class="text-sm bg-gray-100 p-3 rounded text-gray-700">
                    <div class="font-semibold">
                        {{
                            __('Código de departamento inválido: :code', { code: $store.state.perfil.department_code })
                        }}
                    </div>

                    {{
                        __(
                            'Se você é responsável por essa integração, por favor verifique se existe um departamento associado à esse código.'
                        )
                    }}
                </div>

                <div v-if="!invalidDepartmentCode" class="mt-unit">
                    <PrimaryButton @click="iniciarConversa()">
                        <span>{{ __('Enviar mensagem') }}</span>

                        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M17 8l4 4m0 0l-4 4m4-4H3"
                            />
                        </svg>
                    </PrimaryButton>
                </div>
            </div>
        </div>
    </Shell>
</template>


<script>
import PrimaryButton from './PrimaryButton'
import Shell from './Shell.vue'
import FormClient from '@App/Vue/Remote/Crud/FormClient'

export default {
    props: ['transition'],
    components: { FormClient, PrimaryButton, Shell },
    data() {
        let deptToken = ''

        if (this.$store.state.perfil.department_code) {
            let dept = this.$store.state.departamentos.find((dept) => {
                return dept.code == this.$store.state.perfil.department_code
            })
            if (dept) deptToken = dept.token
        }

        return {
            name: this.$store.state.perfil.name,
            email: this.$store.state.perfil.email,
            showName: !this.$store.state.perfil.name,
            showEmail: !this.$store.state.perfil.email,
            showDepartment: !this.$store.state.perfil.department_code,
            departamentoToken: deptToken,
            filialGuanabara: this.$store.state.perfil.filial_origem,
            showFilialGuanabara: !this.$store.state.perfil.filial_origem,
            validationError: null,
        }
    },
    async mounted() {
        this.$nextTick(() => {
            if (this.hasAllRequiredFields()) {
                this.$store.commit('iniciarConversaApósIdentificação', this.departamentoToken)
            }
        })

        if (!this.$store.state.departmentsAvailability) {
            await this.$store.dispatch('loadDepartamentsAvailability')
        }
    },
    computed: {
        título() {
            return this.$store.state.aparência.homeTitle || __('Olá 👋')
        },
        saudação() {
            return this.$store.state.aparência.homeWelcomeMessage || __('Como podemos te ajudar?')
        },

        cor() {
            return this.$store.getters.corPrimária
        },

        availableDepartments() {
            return this.$store.getters.availableDepartments
        },

        invalidDepartmentCode() {
            return this.$store.state.perfil.department_code && !this.departamentoToken
        },

        alreadyHasContact() {
            return this.contact && this.$store.state.salasByTab['chat'].length > 0
        },

        contact() {
            return this.$store.state.contato
        },

        guanabara() {
            return this.$store.state.webMessengerToken == 'xrPAV9AjX2RtvKJlpqEg'
        },

        selectedDepartment() {
            return this.availableDepartments.find((d) => d.token == this.departamentoToken)
        },
    },
    methods: {
        hasAllRequiredFields() {
            let name = this.$store.state.perfil.name
            let email = this.$store.state.perfil.email
            let departmentCode = this.$store.state.perfil.department_code

            if (!name || !email || !departmentCode) return false

            if (this.$refs.formClient) {
                return this.$refs.formClient.isValid()
            }

            return true
        },

        iniciarConversa() {
            if (!this.alreadyHasContact) {
                if (!this.name || !this.email || !this.departamentoToken) {
                    this.validationError = __('Por favor, preencha todos os campos.')
                    return
                }
            }

            if (this.$refs.formClient) {
                if (!this.$refs.formClient.isValid()) {
                    return
                }

                let data = this.$refs.formClient.serialize()
                Object.keys(data).forEach((key) => {
                    this.$store.commit('atualizarPerfil', { chave: key, valor: data[key] })
                })
            }

            this.$store.commit('atualizarPerfil', { chave: 'name', valor: this.name })
            this.$store.commit('atualizarPerfil', { chave: 'email', valor: this.email })

            if (this.guanabara) {
                this.$store.commit('atualizarPerfil', { chave: 'filial_origem', valor: this.filialGuanabara })
            }

            this.$store.commit('iniciarConversaApósIdentificação', this.departamentoToken)
        },
        voltar() {
            this.$store.dispatch('transiçãoParaEsquerda', 'home')
        },
    },
}
</script>